import { CSSProperties } from "react";

const badgeStyle: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 20,
  height: 16,
  padding: "0 6px",
  borderRadius: 8,
  background: "rgba(255, 255, 255, 0.28)",
  fontSize: 10.5,
  fontWeight: 700,
  lineHeight: 1,
  fontVariantNumeric: "tabular-nums",
  flexShrink: 0,
};

/** The points value shown on a complexity option pill. */
export default function ComplexityBadge({ value }: { value?: number | string }) {
  if (value === undefined || value === null || value === "") return null;
  return <span style={badgeStyle}>{value}</span>;
}
